import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import Profile from './Profile';
import useAuth from "../Hooks/useAuth";
import Footer from './home/Footer';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const Header = ({ profileImage }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const authCtx = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Track window width for responsive behavior
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Determine if we're on mobile
  const isMobile = windowWidth <= 767;

  const handleChatClick = (e) => {
    e.preventDefault();
    const primaryChatId = localStorage.getItem('primaryChatId');
    const targetPath = primaryChatId ? `/chat?id=${primaryChatId}` : '/chat';

    if (location.pathname === targetPath && location.search === (primaryChatId ? `?id=${primaryChatId}`: '')) {
      // If already on the correct chat page (with or without ID), reload to ensure freshness or handle specific logic.
      // For now, simple reload. Consider if more nuanced behavior is needed if already on /chat with no ID and primaryChatId exists.
      window.location.reload(); 
    } else {
      navigate(targetPath);
    }
  };

  return (
    <header className="main-header">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="headerRow" style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
              <span className="click">
                <FontAwesomeIcon icon={icon({ name: "bars" })} color="#1C9BBF" onClick={() => setIsOpen(true)} />
              </span>
              <div className={`main_menu ${isOpen ? 'mobile_open' : 'mobile_close'}`} style={{ width: isOpen ? '100%' : '0%' }}>
                <button className="closebtn" onClick={() => setIsOpen(false)} >&times;</button>
                <ul>
                  {!authCtx.isLoggedIn && (
                    <li className='m-login'>
                      <NavLink className={({ isActive }) => isActive ? "current-menu-item" : ''} to="/login">Login</NavLink>
                    </li>
                  )}
                  <li><NavLink className={({ isActive }) => isActive ? "current-menu-item" : ''} to="/">HOME</NavLink></li>
                  <li>
                    <NavLink
                      to={localStorage.getItem('primaryChatId') ? `/chat?id=${localStorage.getItem('primaryChatId')}` : '/chat'}
                      className={({ isActive }) => isActive ? "current-menu-item" : ''}
                      onClick={handleChatClick}
                    >
                      Chat
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to={localStorage.getItem('primaryRealtimeChatId') ? `/realtime-chat?id=${localStorage.getItem('primaryRealtimeChatId')}` : '/realtime-chat'}
                      className={({ isActive }) => isActive ? "current-menu-item" : ''}
                      style={{ position: 'relative', overflow: 'visible' }}
                    >
                      Voice&nbsp;Chat
                      <span className="new-badge">NEW!</span>
                    </NavLink>
                  </li>
                  <li><NavLink className={({ isActive }) => isActive ? "current-menu-item" : ''} to="/plans-pricing">Plans &amp; Pricing</NavLink></li>
                  <li><NavLink className={({ isActive }) => isActive ? "current-menu-item" : ''} to="/blogs">Blog</NavLink></li>
                  {isMobile && (
                    <li>
                      <NavLink 
                        to="/affiliate-program" 
                        className={({ isActive }) => isActive ? "current-menu-item promo-entry" : "promo-entry"}
                      >
                        💰 Affiliate Program
                      </NavLink>
                    </li>
                  )}
                </ul>
                <div className='mobile-footer'>
                  <Footer />
                </div>
              </div>

              <div style={{ flex: '1' }}></div>
              <div style={{ flex: '1', display: 'flex', justifyContent: 'flex-end' }}>
                <div className="headerRight" style={{ width: 'auto' }}>
                  {!authCtx.isLoggedIn ? (
                    <ul>
                      <li><NavLink className={({ isActive }) => isActive ? "current-menu-item" : ''} to="/registration"><span className='block'>Sign up</span></NavLink></li>
                      <li className='d-log'><NavLink className={({ isActive }) => isActive ? "current-menu-item" : ''} to="/login">Login</NavLink></li>
                    </ul>
                  ) : (
                    <Profile image={profileImage} />
                  )}
                </div>
              </div>

              <div 
                className="logo" 
                style={{ 
                  position: 'absolute',
                  ...(isMobile 
                    ? { left: '50%', transform: 'translateX(-50%)', top: '15px' }
                    : { left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }
                  ),
                  maxWidth: 'initial', 
                  margin: '0',
                  zIndex: 5 
                }}
              >
                <NavLink to="/"> <img src="/assets/images/logo.png" alt="" /> </NavLink>
              </div>

              {!isMobile && (
                <div style={{ 
                  position: 'absolute', 
                  right: '28%',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  zIndex: 4
                }}>
                  <NavLink 
                    to="/affiliate-program" 
                    className={({ isActive }) => isActive ? "current-menu-item promo-entry" : "promo-entry"}
                    style={{ 
                      color: '#fff', 
                      whiteSpace: 'nowrap', 
                      textTransform: 'uppercase',
                      padding: '15px',
                      display: 'block',
                      textAlign: 'center'
                    }}
                  >
                    💰 Affiliate Program
                  </NavLink>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
